import { Component, OnInit } from '@angular/core';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { SkillTreeManagementService } from './skill-tree-management.service';

@Component({
  selector: 'app-skill-tree-management',
  templateUrl: './skill-tree-management.component.html',
  styleUrls: ['./skill-tree-management.component.scss']
})
export class SkillTreeManagementComponent implements OnInit {
  allSkillTree;
  page = 1;
  pageSize = 10;
  rows: any[];
  collectionSize: number;
  search: string;
  searchSkillTree: any = '';
  isSearch: boolean = false;

  constructor(
    private skillTreeManagementService: SkillTreeManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.getAllSkillTree();
    this.gobalFunctionService.setTitle('การจัดการ Skill Tree');
  }

  getAllSkillTree() {
    this.skillTreeManagementService.getAllSkilltree().subscribe(res => {
      // // console.log(res);
      res.result.map((st, i) => res.result[i].TREE_NODES = st.TREE_NODES);
      this.allSkillTree = res.result;
      this.refresh();
    })
  }

  getCountCourse(c) {
    return `${JSON.parse(c).length - 5} คอร์ส`;
  }

  getTeacherName(teachers) {
    let name = [];
    teachers.map(t => name.push(' ' + t.USERNAME));
    return name;
  }

  addSkillTree() {
    window.open('/skill-tree-management/manage-skill-tree?isEdit=false', '_blank');
  }

  edit(id) {
    window.open('/skill-tree-management/manage-skill-tree?isEdit=true&skilltree_id=' + id, '_blank');
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchSkillTree = [];
      this.allSkillTree.filter(st => {
        if (st.TREE_NAME.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchSkillTree.push(st)
        }
      });
      this.refreshSearch();
    } else {
      this.isSearch = false
      this.searchSkillTree = null;
      this.getAllSkillTree();
    }
  }

  refresh() {
    this.collectionSize = this.allSkillTree.length;
    this.rows = this.allSkillTree
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  refreshSearch() {
    this.collectionSize = this.searchSkillTree.length;
    this.rows = this.searchSkillTree
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
